var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateCountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.70856,
    y: 0.317935,
    width: 7.11568,
    height: 7.11568,
    rx: 0.953804,
    fill: "white",
    stroke: "#201CE0",
    strokeWidth: 0.63587
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.01325,
    y: 2.01325,
    width: 7.11568,
    height: 7.11568,
    rx: 0.953804,
    fill: "white",
    stroke: "#201CE0",
    strokeWidth: 0.63587
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.317935,
    y: 3.70954,
    width: 7.11568,
    height: 7.11568,
    rx: 0.953804,
    fill: "white",
    stroke: "#201CE0",
    strokeWidth: 0.63587
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateCountIcon);
export default __webpack_public_path__ + "static/media/template-count-icon.77a06634bcbffda70c990555c1ca8aa0.svg";
export { ForwardRef as ReactComponent };